import { FormEvent, useState } from "react";

import { SearchWorkflowTasksResponse } from "../../../../service/query";
import { ServiceError, Status } from "../../../../service/Shared";
import { getErrorMessageFromCode } from "../../../../service/ValidationErrorFormatter";
import { deleteWorkflowTask } from "../../../../service/workflow/WorkflowService";
import { useIsLoadingWrapper } from "../../../../utils";
import { Toast } from "../../../../widget";

interface UseDeleteTaskModalProps {
  closeModal: () => void;
  closePanel: () => void;
  handleRefresh: () => void;
  task?: SearchWorkflowTasksResponse["results"][0];
}

interface UseDeleteTaskModalReturnData {
  handleDeleteTask: (e: FormEvent<HTMLFormElement>) => void;
  isHandleDeleteTaskLoading: boolean;
  handleCloseModal: () => void;
  errors: ServiceError[];
}

export const useDeleteTaskModal = ({
  closeModal,
  closePanel,
  handleRefresh,
  task,
}: UseDeleteTaskModalProps): UseDeleteTaskModalReturnData => {
  const [errors, setErrors] = useState<ServiceError[]>([]);
  const [isHandleDeleteTaskLoading, setIsHandleDeleteTaskLoading] = useState(false);
  const handleCloseModal = (): void => {
    setErrors([]);
    closeModal();
  };

  const handleClosePanel = (): void => {
    setErrors([]);
    closePanel();
  };

  const handleDeleteTask = useIsLoadingWrapper(async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setErrors([]);

    if (!task) {
      setErrors([
        {
          code: "NO_TASK",
          message: "A task must be selected",
        },
      ]);
    } else {
      await deleteWorkflowTask({
        workflowTaskRowVersion: task.rowVersion,
        workflowTaskUuid: task.uuid,
      }).then((response) => {
        if (response.status === Status.Success) {
          Toast.success({ message: "Task successfully deleted" });

          handleRefresh();
          handleClosePanel();
        }
        if (response.status === Status.Error && response.errors) {
          setErrors(response.errors.map((error) => ({ ...error, message: getErrorMessageFromCode(error.code) })));
        }
      });
    }
  }, setIsHandleDeleteTaskLoading);

  return {
    handleDeleteTask,
    handleCloseModal,
    isHandleDeleteTaskLoading,
    errors,
  };
};
